/**
 * AlertsNotificationContainer.jsx
 * Created by michaelbray on 10/3/17
 */

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import AlertsNotification from '../../components/navigation/alerts/AlertsNotification';

import * as alertActions from '../../actions/navigation/alertActions';

export default connect(
    (state) => ({
        alerts: state.alertsNotification.alerts,
        locationParams: state.alertsNotification.locationParams
    }),
    (dispatch) => bindActionCreators(alertActions, dispatch)
)(AlertsNotification);
